import React, { memo } from "react"
import SourceName from "../SourceName/SourceName"
import styles from "./Block.module.css"
import Inline from "./Inline"
import { tokenize } from "string-punctuation-tokenizer"

function countWordsInString(string) {
  const tokenizeOptions = {
    text: string,
    includeWords: true,
    includeNumbers: true,
    includeWhitespace: false,
    includePunctuation: false,
    greedy: true,
    verbose: false,
  }
  let words = tokenize(tokenizeOptions)
  return words
}

function getSpeechWordCount(inlines) {
  let totalwords = []
  inlines.forEach(inline => {
    if (inline.type === "table") {
      const tableRows = inline.children
      tableRows.forEach(row => {
        const tableCells = row.children
        tableCells.forEach(cell => {
          const leaves = cell.children
          leaves.forEach(leaf => {
            const { text, tag, note } = leaf
            if (
              (tag && (tag.indexOf("v") !== -1 || tag.indexOf("c") !== -1)) ||
              note
            ) {
              return
            }
            totalwords = [...totalwords, ...countWordsInString(text)]
          })
        })
      })
    } else {
      const leaves = inline.children
      leaves.forEach(leaf => {
        const { text, tag, note } = leaf
        if (
          (tag && (tag.indexOf("v") !== -1 || tag.indexOf("c") !== -1)) ||
          note
        ) {
          return
        }
        totalwords = [...totalwords, ...countWordsInString(text)]
      })
    }
  })
  return totalwords
}

const Block = memo(
  ({
    bIndex,
    content,
    verbViewDialog,
    newSourceViewDialog,
    newInterlinearDialog,
    newSphereViewDialog,
    newValuesDialog,
    language,
    version,
    versification,
    showSpheres,
    showValues,
    versificationType,
    availableBooks,
    navigateToRef,
    translate,
    displayRef,
    showQA,
    showGAP,
  }) => {
    const { children, source: sourceData } = content
    const TPMark = null

    if (language === "HBR" || language === "ARB") {
      if (sourceData === "Editorial Insert") {
        return (
          <div className={styles.hebrew}>
            <div className={styles.editorialInsert}>
              {children.map((inline, iIndex) => (
                <Inline
                  key={`${bIndex}-${iIndex}`}
                  versification={versification}
                  version={version}
                  language={language}
                  showSpheres={showSpheres}
                  showValues={showValues}
                  iIndex={`${bIndex}-${iIndex}`}
                  type={inline.type}
                  content={inline}
                  verbViewDialog={verbViewDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  newValuesDialog={newValuesDialog}
                  versificationType={versificationType}
                  availableBooks={availableBooks}
                  navigateToRef={navigateToRef}
                  translate={translate}
                  displayRef={displayRef}
                  showQA={showQA}
                  showGAP={showGAP}
                />
              ))}
            </div>
          </div>
        )
      }
      if (sourceData === "Psalm Title") {
        return (
          <div className={styles.hebrew}>
            <div className={styles.psalmTitle}>
              {children.map((inline, iIndex) => (
                <Inline
                  key={`${bIndex}-${iIndex}`}
                  isPsalmHeader={true}
                  versification={versification}
                  version={version}
                  language={language}
                  showSpheres={showSpheres}
                  showValues={showValues}
                  iIndex={`${bIndex}-${iIndex}`}
                  type={inline.type}
                  content={inline}
                  verbViewDialog={verbViewDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  newValuesDialog={newValuesDialog}
                  versificationType={versificationType}
                  availableBooks={availableBooks}
                  navigateToRef={navigateToRef}
                  translate={translate}
                  displayRef={displayRef}
                  showQA={showQA}
                  showGAP={showGAP}
                />
              ))}
            </div>
          </div>
        )
      }
      return (
        <div className={styles.hebrew}>
          <SourceName
            sourceName={sourceData.sourceName}
            data={sourceData}
            newSourceViewDialog={newSourceViewDialog}
            words={getSpeechWordCount(children)}
            timePeriods={TPMark && TPMark[0] ? TPMark[0].data.timePeriod : null}
          />
          <div
            className={
              sourceData.color === "red" ||
              sourceData.color === "green" ||
              sourceData.color === "blue"
                ? [styles.speechbubblehebrew, styles[sourceData.color]].join(
                    " "
                  )
                : {}
            }
          >
            {children.map((inline, iIndex) => (
              <Inline
                key={`${bIndex}-${iIndex}`}
                versification={versification}
                version={version}
                language={language}
                showSpheres={showSpheres}
                showValues={showValues}
                iIndex={`${bIndex}-${iIndex}`}
                type={inline.type}
                content={inline}
                verbViewDialog={verbViewDialog}
                newInterlinearDialog={newInterlinearDialog}
                newSphereViewDialog={newSphereViewDialog}
                newValuesDialog={newValuesDialog}
                versificationType={versificationType}
                availableBooks={availableBooks}
                navigateToRef={navigateToRef}
                translate={translate}
                displayRef={displayRef}
                showQA={showQA}
                showGAP={showGAP}
              />
            ))}
          </div>
        </div>
      )
    } else {
      if (sourceData === "Editorial Insert") {
        return (
          <div>
            <div className={styles.editorialInsert}>
              {children.map((inline, iIndex) => (
                <Inline
                  key={`${bIndex}-${iIndex}`}
                  versification={versification}
                  version={version}
                  language={language}
                  showSpheres={showSpheres}
                  showValues={showValues}
                  iIndex={`${bIndex}-${iIndex}`}
                  type={inline.type}
                  content={inline}
                  verbViewDialog={verbViewDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  newValuesDialog={newValuesDialog}
                  versificationType={versificationType}
                  availableBooks={availableBooks}
                  navigateToRef={navigateToRef}
                  translate={translate}
                  displayRef={displayRef}
                  showQA={showQA}
                  showGAP={showGAP}
                />
              ))}
            </div>
          </div>
        )
      }

      if (sourceData === "Psalm Title") {
        return (
          <div>
            <div className={styles.psalmTitle}>
              {children.map((inline, iIndex) => (
                <Inline
                  key={`${bIndex}-${iIndex}`}
                  isPsalmHeader={true}
                  versification={versification}
                  version={version}
                  language={language}
                  showSpheres={showSpheres}
                  showValues={showValues}
                  iIndex={`${bIndex}-${iIndex}`}
                  type={inline.type}
                  content={inline}
                  verbViewDialog={verbViewDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  newValuesDialog={newValuesDialog}
                  versificationType={versificationType}
                  availableBooks={availableBooks}
                  navigateToRef={navigateToRef}
                  translate={translate}
                  displayRef={displayRef}
                  showQA={showQA}
                  showGAP={showGAP}
                />
              ))}
            </div>
          </div>
        )
      }
      return (
        <div>
          <SourceName
            sourceName={sourceData.sourceName}
            data={sourceData}
            newSourceViewDialog={newSourceViewDialog}
            words={getSpeechWordCount(children)}
            timePeriods={TPMark && TPMark[0] ? TPMark[0].data.timePeriod : null}
          />
          <div
            className={
              sourceData.color !== "black"
                ? [styles.speechbubble, styles[sourceData.color]].join(" ")
                : {}
            }
          >
            {children.map((inline, iIndex) => (
              <Inline
                key={`${bIndex}-${iIndex}`}
                versification={versification}
                version={version}
                language={language}
                showSpheres={showSpheres}
                showValues={showValues}
                iIndex={`${bIndex}-${iIndex}`}
                type={inline.type}
                content={inline}
                verbViewDialog={verbViewDialog}
                newInterlinearDialog={newInterlinearDialog}
                newSphereViewDialog={newSphereViewDialog}
                newValuesDialog={newValuesDialog}
                versificationType={versificationType}
                availableBooks={availableBooks}
                navigateToRef={navigateToRef}
                translate={translate}
                displayRef={displayRef}
                showQA={showQA}
                showGAP={showGAP}
              />
            ))}
          </div>
        </div>
      )
    }
  }
)

export default Block
